export default [
  {
    path: '/organization-onboard/list',
    name: 'organization-onboard-list',
    component: () => import('@/views/organization/onboard/index.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Organization Onboard List',
      breadcrumb: [{ title: 'Dashboard', url: '/dashboard' }, { title: 'Organization Onboard' }, { title: 'Organization Onboard List', active: true }],
      permissions: ['organization_onboard_list']
    }
  }
]
